"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uuid = require("uuid");

var _utils = require("./utils");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Helper for working with batches, which consist of a number of items that can
 * be processed. The manager provides a way of specifying how many items are in the
 * batch, along with a notification mechanism that indicates when all items in the
 * batch are finished.
 */
var BatchManager = /*#__PURE__*/function () {
  /**
   * Initializes a new instance of the manager.
   */
  function BatchManager() {
    _classCallCheck(this, BatchManager);

    this.batchCounts = {};
  }
  /**
   * Creates a new batch that will consist of a given number of items.
   * @param {number} totalCount Number of items in the batch.
   * @param {function} callback Invoked when all items in the batch have
   *  been processed.
   * @returns {string} A unique identifier for the new batch.
   */


  _createClass(BatchManager, [{
    key: "createBatch",
    value: function createBatch(totalCount, callback) {
      var batchId = (0, _uuid.v4)();
      this.batchCounts[batchId] = {
        totalCount: totalCount,
        totalProcessed: 0,
        callback: callback
      };
      return batchId;
    }
    /**
     * Increments the number of items in a given batch that have been processed.
     * If all items have been processed, the method will also invoke the callback
     * indicating the batch is complete.
     *
     * The method is "thread safe", meaning calling the method concurrently will
     * ensure that the final callback is only called once.
     * @param {string} batchId Unique identifier for the batch to update.
     * @returns {Promise} Will resolve when the batch has been safely updated.
     */

  }, {
    key: "updateBatch",
    value: function () {
      var _updateBatch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(batchId) {
        var _this = this;

        var batchEnded, callback;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                batchEnded = false; // since we're dealing with concurrency, be safe and lock the batch
                // when incrementing to ensure we avoid concurrency issues.

                _context.next = 3;
                return (0, _utils.getLock)(batchId, function () {
                  _this.batchCounts[batchId].totalProcessed += 1;
                  var _this$batchCounts$bat = _this.batchCounts[batchId],
                      totalCount = _this$batchCounts$bat.totalCount,
                      totalProcessed = _this$batchCounts$bat.totalProcessed;
                  batchEnded = totalCount === totalProcessed;
                });

              case 3:
                // this may same weird, but doing it this way to ensure that
                // "callback()" is not invoked inside the lock.
                if (batchEnded) {
                  callback = this.batchCounts[batchId].callback;
                  callback();
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateBatch(_x) {
        return _updateBatch.apply(this, arguments);
      }

      return updateBatch;
    }()
  }]);

  return BatchManager;
}();

exports.default = BatchManager;